import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../useTable";
//UI
import { DangerButton, SuccessButton } from '../../../../ui/buttons/Button'
import { Dimmer } from "../../../spinner";
import { Mensaje } from "../../../mensajes2";
import { SearchInput } from "../../../../ui/inputs/Input";
import axios from "axios";
import { selectClasses } from "@mui/material";

const headCells = [
    {
        id: "codigo",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Código",
        textAlign: "center",
    },
    {
        id: "nombre",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Nombre",
        textAlign: "center",
    },
    {
        id: "proximo",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Periodo Actual",
        textAlign: "center",
    },
    {
        id: "anioCurso",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Año en Curso",
        textAlign: "center",
    },
];

export default function SeleccionarNomina(props) {
    const nominaSel = JSON.parse(localStorage.getItem('codigonomina'));
    let op = require("../../../../../src/modulos/datos");
    let token = localStorage.getItem('jwtToken');
    const fechasis = JSON.parse(localStorage.getItem("fechasistema"));
    const [records, setRecords] = useState([]);
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [select, setSelect] = useState(false);
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);

    const [filterFn, setFilterFn] = useState({ fn: (items) => { return items; }, });
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const salir = () => {
        blanquear();
        props.onHideCancela('');
    };

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    //alert(JSON.stringify(items))
                    return items.filter((x) => {
                        //alert(JSON.stringify(x.codnomi) + "     " + JSON.stringify(x.titnomi) + "     " + JSON.stringify(x.proximo));
                        if (
                            (x.codnomi.toLowerCase().includes(target.value.toLowerCase()) === null
                                ? ""
                                : x.codnomi.toLowerCase().includes(target.value.toLowerCase())) ||

                            (x.titnomi === null
                                ? ""
                                : x.titnomi.toLowerCase().includes(target.value.toLowerCase())) ||
                            (x.proximo === null
                                ? ""
                                : x.proximo.toString().includes(target.value.toLowerCase())) ||
                            (x.aniocurso === null
                                ? ""
                                : x.aniocurso.toString().includes(target.value))
                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };

    const seleccionarNominas = () => {
        setActivate(true);
        let condi = 'status = 1';
        let endpoint = `${op.conexion}/api/nomina/seleccionarregistrosnominacondi?condi=${condi}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status == 200) {
                setActivate(false);
                setRecords(response.data);
            }
        }).catch(function (error) {
            /*setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });*/
            setActivate(false);
            props.onHideCancela(error.response.data.message);
        })
    }

    const blanquear = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        setItemSelect("");
        setSelect("")
        setActivate(false);
        setRecords([]);
        setActivo(true);
        setFilterFn({ fn: items => { return items; } });
    }
    const cancelar = () => {
        blanquear();
        if (props.onHideCancelar) props.onHideCancelar();
        if (props.setShow) props.setShow(false);
    }

    const cerrarModal = () => {
        if (props.onHideCancelar) { props.onHideCancelar(); }
        if (props.setShow) props.setShow(false);

        blanquear()
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
    }

    const seleccionarNomina = (event) => {
        event.preventDefault();
        seleccionarPeriodo(values[0].codigonomina, values[0].numperiodo);
    };

    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        //setSelect(parseInt(nominaSel));
        var codigonomina = recordsAfterPagingAndSorting()[index].codnomi;
        var titulonomina = recordsAfterPagingAndSorting()[index].titnomi;
        var aniocurso = recordsAfterPagingAndSorting()[index].aniocurso;
        var numperiodo = recordsAfterPagingAndSorting()[index].proximo;
        var codigootropago = null;
        var titulotropago = null;

        var datos = [];
        datos.push({
            codigonomina,
            titulonomina,
            aniocurso,
            numperiodo,
            codigootropago,
            titulotropago
        })
        setValues(datos);
    };

    const seleccionarPeriodo = (codnomi, numper) => {
        setActivate(true);
        let campos = "*";
        let id = codnomi;
        let id2 = numper;
        let nomtab = "periodos";
        let nomid = "codnomi";
        let nomid2 = "numper";
        let orden = "1";
        let endpoint = `${op.conexion}/api/consulta/idsstring2?campos=${campos}&id=${id}&id2=${id2}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data.fecini !== ""){
                    var codigonomina = values[0].codigonomina;
                    var titulonomina = values[0].titulonomina;
                    var aniocurso = values[0].aniocurso;
                    var numperiodo = values[0].numperiodo;
                    var codigootropago = null;
                    var titulotropago = null;
    
    
                    localStorage.setItem('codigonomina', JSON.stringify(codigonomina));
                    localStorage.setItem('titulonomina', JSON.stringify(titulonomina));
                    localStorage.setItem('aniocurso', JSON.stringify(aniocurso));
                    localStorage.setItem('numperiodo', JSON.stringify(numperiodo));
                    localStorage.setItem('codigootropago', JSON.stringify(codigootropago));
                    localStorage.setItem('titulotropago', JSON.stringify(titulotropago));
                    localStorage.setItem('fechainiper', JSON.stringify(response.data.fecini));
                    localStorage.setItem('fechafinper', JSON.stringify(response.data.fecfin));
                    localStorage.setItem('fechanomina', JSON.stringify(fechasis));

                    localStorage.setItem('codigootropago', null);
                    localStorage.setItem('titulotropago', null);
                    blanquear();
                    props.onHideAcepta();
                } else {
                    setMensaje({
                        mostrar: true,
                        titulo: "ERROR",
                        texto: "El período actual de la nomina que esta seleccionando no existe verifiquelo",
                        icono: "error",
                    });        
                }
            }
            setActivate(false)
        }).catch(function (error) {
            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });
            setActivate(false)
        })
    }

    return <Modal
        size="lg"
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
        backdrop="static"
        keyboard={false}
        onShow={() => {
            seleccionarNominas();
            //setSelect(nominaSel)
        }}
    >
        <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
            <h3 className="fw-bold m-0">Seleccionar Nómina</h3>
            <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
                Salir <i className="fa fa-times ms-2"></i>
            </a>
        </Modal.Header>
        <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
            <Dimmer active={activate} inverted>

            </Dimmer>
            <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
                <input type='text' placeholder="Buscar"
                    onChange={handleSearch} className="form-control search-input rounded-pill" />
            </div>
            <div className="col-12 m-0 p-0">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {records &&
                            recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={item.codnomi} style={{ padding: "0", cursor: 'pointer', backgroundColor: select === parseInt(item.codnomi) ? "lightskyblue" : itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                    <td className='py-2 text-center'>{item.codnomi}</td>
                                    <td className='py-2 text-start'>{item.titnomi}</td>
                                    <td className='py-2 text-center'>{item.proximo}</td>
                                    <td className='py-2 text-center'>{item.aniocurso}</td>
                                </tr>
                            ))}
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
        </Modal.Body>
        <Modal.Footer>
            <SuccessButton onClick={seleccionarNomina} disabled={activo}>
                Aceptar
            </SuccessButton>
            <DangerButton onClick={salir}>
                Cancelar
            </DangerButton>
        </Modal.Footer>
        <Mensaje
            mensaje={mensaje}
            onHide={() => {
                setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
            }}
        />
    </Modal>
}